import React from 'react';
import { useEmergency } from '../contexts/EmergencyContext';

/**
 * EmergencyStatusBanner 컴포넌트
 * Emergency가 확인된 상태에서 대시보드 상단에 표시되는 상태 배너
 */
const EmergencyStatusBanner = () => {
  const { emergencyState, clearEmergency } = useEmergency();

  // Emergency가 활성화되고 확인된 상태에서만 표시
  if (!emergencyState.isActive || !emergencyState.isAcknowledged) {
    return null;
  }

  const handleResolve = () => {
    console.log('[EmergencyStatusBanner] 알람 해지 버튼 클릭');
    clearEmergency();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: '#8B0000',
      color: 'white',
      padding: '12px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: '0 2px 8px rgba(139, 0, 0, 0.3)',
      zIndex: 1000,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {/* 왼쪽: Emergency 상태 정보 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
        {/* 깜빡이는 아이콘 */}
        <div style={{ 
          fontSize: '20px',
          animation: 'emergency-blink 1s ease-in-out infinite'
        }}>
          🚨
        </div>
        
        {/* 메시지 */}
        <div>
          <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
            Emergency 상황 진행 중
          </div>
          <div style={{ fontSize: '12px', opacity: 0.9 }}>
            {emergencyState.triggeredBy.length === 1 ? (
              <span>
                {emergencyState.lastTrigger?.chartTitle} - {emergencyState.lastTrigger?.condition}
              </span>
            ) : (
              <span>
                {emergencyState.triggeredBy.length}개 차트에서 Emergency 발생
              </span>
            )}
          </div>
        </div>
      </div>

      {/* 오른쪽: 해지 버튼 */}
      <button
        onClick={handleResolve}
        style={{
          backgroundColor: '#28A745',
          color: 'white',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '6px',
          fontSize: '14px',
          fontWeight: 'bold',
          cursor: 'pointer',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#218838';
          e.target.style.transform = 'translateY(-1px)';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = '#28A745';
          e.target.style.transform = 'translateY(0)';
        }}
      >
        🛠️ 알람 해지
      </button>

      {/* CSS 애니메이션 */}
      <style jsx>{`
        @keyframes emergency-blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }
      `}</style>
    </div>
  );
};

export default EmergencyStatusBanner; 